import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";
import { func, bool, string, shape } from "prop-types";

import { actions as recoveryPasswordActions } from "reducers/recoveryPassword";
import * as i18n from "util/i18n";

import Box from "pages/_components/Box";
import I18n from "pages/_components/I18n";
import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import Captcha from "pages/_components/fields/credentials/Captcha";
import Container from "pages/_components/Container";
import Credential from "pages/_components/fields/credentials/Credential";
import { Mixpanel } from "util/clickstreaming";
import Logo from "pages/login/_components/Logo";

const FORM_ID = "recoveryPassword.step1";

const recoveryI18n = {
    password: "recoveryPassword",
    username: "recoveryUsername",
};

const recoveryText = {
    password: "contraseña",
    username: "usuario",
};

class Step1Content extends Component {
    onVerify = (value) => {
        const { setFieldValue } = this.props;
        setFieldValue("captcha", value);
    };

    render() {
        const { isSubmitting, showCaptcha, isMobileNative, isDesktop, deviceStatus } = this.props;
        const recoveryType = this.props?.match?.params?.recoveryType;

        return (
            <>
                {isDesktop && (
                    <div className="text-center">
                        <Logo className="svg-image logo" />
                    </div>
                )}
                <h1 className="text-center">
                    <I18n
                        id={`${recoveryI18n[recoveryType]}.step1.header`}
                        defaultValue={`Recuperar mi ${recoveryText[recoveryType]}`}
                    />
                </h1>
                <Form className="above-the-fold  login-desktop-wrapper">
                    <Container className="flex-grow items-center container--layout">
                        <Box>
                            <I18n
                                component="p"
                                id={`${recoveryI18n[recoveryType]}.step1.title`}
                            />

                            <Field
                                name="username"
                                idForm={FORM_ID}
                                labelText="administration.channels.cuil"
                                onlyNumbers
                                autoComplete="on"
                                maxLength={50}
                                component={TextField}
                                placeholder="Ej: 20123456781"
                            />

                            {deviceStatus === "NO_DEVICE" ? (
                                <Field
                                    labelText="form.credential.otp.label"
                                    name="secondFactor"
                                    idForm={FORM_ID}
                                    component={Credential}
                                    type="otp"
                                />
                            ) : null}

                            <Button
                                className="mb-8"
                                label="global.continue"
                                type="submit"
                                bsStyle="primary"
                                loading={isSubmitting}
                                block
                            />

                            <I18n
                                component="p"
                                componentProps={{ className: "font-size-md" }}
                                id="recoveryPassword.step1.footer"
                            />

                            <Link to={`/recovery/${recoveryType}/step2`} className="d-flex justify-content-center">
                                <Button
                                    label="recoveryPassword.step1.userHasCode"
                                    type="button"
                                    bsStyle="link"
                                    loading={isSubmitting}
                                />
                            </Link>
                        </Box>
                    </Container>
                    {showCaptcha && !isMobileNative && <Field name="captcha" idForm={FORM_ID} component={Captcha} />}
                </Form>
            </>
        );
    }
}

Step1Content.propTypes = {
    isSubmitting: bool,
    setFieldValue: func.isRequired,
    showCaptcha: bool,
    isMobileNative: bool,
    deviceStatus: string.isRequired,
    tokenInfo: shape({}).isRequired,
};

Step1Content.defaultProps = {
    isSubmitting: false,
    showCaptcha: true,
    isMobileNative: false,
};

export default withFormik({
    validateOnChange: false,
    validateOnBlur: false,
    mapPropsToValues: () => ({ username: "", secondFactor: "", captcha: "" }),
    validationSchema: ({ isMobileNative, showCaptcha, deviceStatus }) =>
        Yup.object().shape({
            username: Yup.string().required(i18n.get(`${FORM_ID}.username.required`)),
            secondFactor:
                deviceStatus === "NO_DEVICE"
                    ? Yup.string().required(i18n.get(`${FORM_ID}.secondFactor.required`))
                    : Yup.string(),
            captcha:
                !isMobileNative && showCaptcha
                    ? Yup.string().required(i18n.get(`${FORM_ID}.captcha.required`))
                    : Yup.string(),
        }),
    handleSubmit: (values, formikBag) => {
        Mixpanel.track(FORM_ID);
        const token =
            formikBag.props.deviceStatus === "NO_DEVICE" ? values.secondFactor : formikBag.props.tokenInfo.token;
        formikBag.props.dispatch(
            recoveryPasswordActions.recoveryPassStep1(values.username, token, values.captcha, formikBag),
        );
    },
})(Step1Content);
